import React from 'react';
import ReactDOM from 'react-dom/client';
import './assets/css/index.css';
// import App from './App';
import Top from './components/pages/Top/index';
//import Top from './components/pages/TopTest';
import reportWebVitals from './reportWebVitals';
// recoil state manger
import { RecoilRoot } from 'recoil';
import { Helmet } from 'react-helmet';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <Helmet>
      <meta Charset="utf-8" />
      <title> 防災かみごおり配信情報一覧 </title>
    </Helmet>

    <RecoilRoot>
      <Top />
    </RecoilRoot>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals(console.log);
